import { connect } from 'react-redux';
import UtilityNav from 'brastrap/common/utility-nav/UtilityNav';

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  openNav: state.browser.deviceIs.desktop,
});

export default connect(mapStateToProps)(UtilityNav);
